document.addEventListener('DOMContentLoaded', function(){

  var root = document.getElementById('md-collection-content');
  if(!root) return;

  var main = root.querySelector('.mdp-collection-details');
  if(!main || !main.id) return;

  var storageOpenKey = 'massilia_collection_open_' + window.location.pathname;
  var storageScrollKey = 'massilia_collection_scroll_' + window.location.pathname;

  if(localStorage.getItem(storageOpenKey) === '1'){
    main.open = true;

    var savedScroll = localStorage.getItem(storageScrollKey);
    if(savedScroll){
      setTimeout(function(){
        window.scrollTo(0, parseInt(savedScroll, 10));
      }, 300);
    }
  }

  main.addEventListener('toggle', function(){
    if(main.open){
      localStorage.setItem(storageOpenKey, '1');
    } else {
      localStorage.removeItem(storageOpenKey);
      localStorage.removeItem(storageScrollKey);
    }
  });

  root.querySelectorAll('a[href]').forEach(function(link){
    link.addEventListener('click', function(){
      if(main.open){
        localStorage.setItem(storageOpenKey, '1');
        localStorage.setItem(storageScrollKey, String(window.scrollY));
      }
    });
  });

  var closeBtn = root.querySelector('#md-close-collection');
  if(closeBtn){
    closeBtn.addEventListener('click', function(){
      localStorage.removeItem(storageOpenKey);
      localStorage.removeItem(storageScrollKey);
    });
  }

});